import { render } from "./MyPointHistory.vue?vue&type=template&id=a2c4bb02"
import script from "./MyPointHistory.vue?vue&type=script&lang=js"
export * from "./MyPointHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__